import { Api } from '@axiom/ui';
import type {
  Candidate,
  EnvoyCandidateProfileTopFocusAreas,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateProfileTopFocusAreasApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readProfileTopFocusAreas(id: Candidate['id']) {
    return super.read<{ data: EnvoyCandidateProfileTopFocusAreas }>({
      endpoint: `/candidates/${id}/profileTopFocusAreas`,
      method: 'GET',
    });
  }

  async refreshProfileTopFocusAreas(id: Candidate['id']) {
    return super.invalidate(`/candidates/${id}/profileTopFocusAreas`);
  }
}

export const CandidateProfileTopFocusAreasApi =
  new CandidateProfileTopFocusAreasApiClass();
